module.exports = __webpack_public_path__ + "static/media/trash.65977d4a.svg";